export default function PrimaryButton({ children, onClick, disabled = false, variant = "solid" }) {
  return (
    <button className={`su-button su-button--${variant}`} type="button" onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}
